import * as React from 'react';

function SvgTipsBasic(props) {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <clipPath id="tips-basic_svg__a">
        <path d="M0 0h20v20H0z" />
      </clipPath>
      <g clipPath="url(#tips-basic_svg__a)">
        <path
          clipRule="evenodd"
          d="M10.55 2.05c0 .3-.2.5-.5.5s-.5-.25-.5-.5V.5c0-.3.2-.5.5-.5s.5.2.5.5zM5.651 14.199A6.15 6.15 0 1114.35 5.5a6.15 6.15 0 01-8.699 8.7zM9.101 19h1.85c.25 0 .5.25.5.5 0 .3-.2.5-.5.5H9.1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5zm3.149-2.05h-4.5c-.3 0-.5.2-.5.5s.2.5.5.5h4.5c.3 0 .5-.2.5-.5s-.25-.5-.5-.5zM4.75 4.6c.2-.2.2-.5 0-.7L3.7 2.8c-.2-.2-.5-.2-.7 0s-.2.5-.05.7l1.1 1.1c.2.2.55.2.7 0zM.5 9.35h1.55c.25 0 .5.2.5.5s-.2.5-.5.5H.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5zm19 .05h-1.55c-.3 0-.5.2-.5.5s.2.5.5.5h1.55c.3 0 .5-.2.5-.5 0-.25-.2-.5-.5-.5zm-4.1-5.55l1.1-1.1c.15-.2.5-.2.7 0s.2.5 0 .7l-1.1 1.1c-.2.2-.5.2-.7 0s-.2-.5 0-.7z"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}

export default SvgTipsBasic;
